import { useMemo } from "react";
import { useTranslations } from "use-intl";

import { Chip } from "@/components/Chip/Chip";
import type { City } from "@/types/types";

type Props = {
  onRecommendationClick: (city: City) => void;
  shouldShow?: (city: City) => boolean;
};

export function CitiesRecommendations({
  onRecommendationClick,
  shouldShow,
}: Props) {
  const t = useTranslations();
  const data = useMemo<City[]>(() => {
    const commonProps = {
      countryName: t("searchRecommendations.iraq"),
      countryCode: "IQ",
      type: "CITY" as const,
    };

    const cities = [
      {
        id: "1",
        name: t("searchRecommendations.baghdad"),
        code: "BGW",
      },
      {
        id: "34",
        name: t("searchRecommendations.mosul"),
        code: "",
      },
      {
        id: "31",
        name: t("searchRecommendations.najaf"),
        code: "NJF",
      },
      {
        id: "33",
        name: t("searchRecommendations.erbil"),
        code: "EBL",
      },
      {
        id: "32",
        name: t("searchRecommendations.basra"),
        code: "BSR",
      },
    ].map((city) => ({ ...commonProps, ...city }));

    if (shouldShow) {
      return cities.filter(shouldShow);
    }

    return cities;
  }, [t, shouldShow]);

  return (
    <ul className="mt-4 -mb-2 flex w-full shrink-0 gap-2 overflow-x-auto pb-2">
      {data.map((city) => (
        <li key={city.id}>
          <Chip
            label={city.name}
            onClick={() => onRecommendationClick(city)}
            color="neutral"
            variant="outlined"
            shape="pill"
            size="medium"
          />
        </li>
      ))}
    </ul>
  );
}
